var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('form', {
    staticClass: "v-form",
    attrs: {
      "novalidate": "",
      "autocomplete": _vm.autocomplete
    },
    on: {
      "submit": _setup.handleSubmit,
      "keyup": _setup.handleKeyup
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };